import { render } from "./OrderReturnInfosModal.vue?vue&type=template&id=2b1df772&scoped=true&ts=true&lang=pug"
import script from "./OrderReturnInfosModal.vue?vue&type=script&lang=ts"
export * from "./OrderReturnInfosModal.vue?vue&type=script&lang=ts"

import "./OrderReturnInfosModal.vue?vue&type=style&index=0&id=2b1df772&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1df772"]])

export default __exports__